<template>
    <div @click="$emit('click', { link, actionType })">
        <img
            class="banner-carousel__image"
            :src="image"
        >
    </div>
</template>

<script>
    export default {
        name: 'Banner',
        props: {
            image: {
                type: String,
                required: true
            },
            link: {
                type: String,
                required: true
            },
            actionType: {
                type: String,
                required: true
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/banners/components/CarouselBanner.vue